module.exports = __webpack_public_path__ + "static/media/0.beginning.cbaca0d6.mp4";